import { Modal, Table } from "../../../../components";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { motion } from "framer-motion";
import { Alert } from "react-bootstrap";
import { usePodadoresStore } from "../../../../store/podadoresStore";
import useWindowSize from "../../../../hooks/useWindowSize";
import { useEffect } from "react";
import { useFormActaStore } from "../../../../store/formActaStore";
import { asignarPodadorHandler } from "../../../../handlers/podadores.handler";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import Loading from "../../../../components/Loading";

const ModalAsignarPodadores = () => {
  const { modals, handlerModal, loads } = useGeneralAppStore();
  const { defaultValues } = useFormActaStore();
  const { width } = useWindowSize();
  const { podadoresSelect } = usePodadoresStore();

  useEffect(() => {
    return () => {
      handlerModal({ modal: false, modalName: "asignar_podadores" });
    };
  }, []);

  return (
    <>
      <Modal
        // fullscreen={true}
        size="lg"
        show={modals.includes("asignar_podadores")}
        onHide={() => {
          handlerModal({ modal: false, modalName: "asignar_podadores" });
        }}
        title={() => "Podadores asignados"}
      >
        <motion.div
          key="form"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="w-100 position-relative"
        >
          {loads.includes("asignar_podador") && (
            <div
              className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
              style={{ zIndex: "99", backgroundColor: "rgba(255,255,255,0.85)" }}
            >
              <Loading sizeIcono="50px" sizeLoad="70px" font="16px" />
            </div>
          )}
          <Alert className="pb-0" variant="primary">
            <b>Desea asignar los siguientes podadores para realizar el trámite?</b>
            <hr />
            {podadoresSelect.map((podador) => {
              return (
                <>
                  {width <= 360 ? (
                    <div key={podador.id} className="d-flex flex-column">
                      {podador.nombre}
                      <p>
                        {" "}
                        <PhoneEnabledIcon sx={{ width: "16px" }} /> <b>{podador.telefono}</b>
                      </p>
                    </div>
                  ) : (
                    <p key={podador.id} className="d-flex">
                      {podador.nombre} - <PhoneEnabledIcon sx={{ width: "16px" }} />{" "}
                      <b>{podador.telefono}</b>
                    </p>
                  )}
                </>
              );
            })}
          </Alert>
          <div className="d-flex gap-2 justify-content-end">
            <button
              className="btn btn-sm btn-danger"
              onClick={() => handlerModal({ modal: false, modalName: "asignar_podadores" })}
            >
              Cancelar
            </button>
            <button
              className="btn btn-sm btn-success"
              onClick={() =>
                asignarPodadorHandler({ podadores: podadoresSelect, acta_id: defaultValues?.id })
              }
            >
              Confirmar
            </button>
          </div>
        </motion.div>
      </Modal>
    </>
  );
};
export default ModalAsignarPodadores;
